import { useTranslation } from "react-i18next";

export interface PackageGridSkeletonProps {
  /** Cuántas tarjetas fantasma. Tres llenan una fila en escritorio. */
  count?: number;
}

/**
 * Lo que se ve mientras los paquetes viajan.
 *
 * Cajas con el alto aproximado de una tarjeta real, no un spinner
 * centrado: cuando llegan los datos, nada se mueve de sitio.
 *
 * El bloque entero es una sola región `aria-busy` con un texto para el
 * lector de pantalla; tres cajas vacías no le dicen nada a nadie.
 */
export function PackageGridSkeleton({ count = 3 }: PackageGridSkeletonProps) {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      aria-busy="true"
      className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3"
    >
      <span className="sr-only">{t("Cargando los paquetes…")}</span>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          aria-hidden="true"
          className="h-[26rem] animate-pulse rounded-ds-xl border border-ds-border bg-white p-6 motion-reduce:animate-none"
        >
          <div className="h-5 w-2/3 rounded-ds-sm bg-ds-mist/70" />
          <div className="mt-4 h-3 w-full rounded-ds-sm bg-ds-mist/50" />
          <div className="mt-2 h-3 w-5/6 rounded-ds-sm bg-ds-mist/50" />
          <div className="mt-2 h-3 w-4/6 rounded-ds-sm bg-ds-mist/50" />
          <div className="mt-8 h-9 w-1/2 rounded-ds-sm bg-ds-mist/70" />
          <div className="mt-8 h-14 w-full rounded-ds-md bg-ds-mist/50" />
        </div>
      ))}
    </div>
  );
}
